import { CreateApi } from "../../CreateApi";
import { Methods, Urls } from "../../../common/Utils/ApiConstants";

const reAllocationRequestCollection = CreateApi.injectEndpoints({
  endpoints: (builder) => ({
    getReAllocationRequestData: builder.query({
      query: (pageNo) => {
        return {
          url: Urls.getReAllocationRequestTaskList,
          method: Methods.get,
          params: { pageNo },
        };
      },
      transformResponse: (response) => {
        return response.data;
      },
    }),
  }),
});
export const { useLazyGetReAllocationRequestDataQuery } =
  reAllocationRequestCollection;
